import styled, { css } from 'styled-components/macro';

export const DirectMerchantP = styled.p`
  ${props =>
    props.color &&
    css`
      color: ${props => props.theme[props.color]};
    `}
  ${props =>
    props.capitalize &&
    css`
      text-transform: capitalize;
    `}
    ${props =>
      props.inlineBlock &&
      css`
        display: inline-block;
      `}
`;

export const SortableSwitchDiv = styled.div`
  display: inline-block;
  cursor: pointer;
`;

export const CustomSpan = styled.span`
  display: inline-block;
  &::first-letter {
    text-transform: uppercase;
  }
`;

export const SubtitleWrapper = styled.div`
  display: flex;
  > p {
    padding-right: 5px;
  }
`;
